import { z } from 'zod';

/** BR-SO-163: placeholders available to a workshop's custom reception term text. */
export const RECEPTION_TERM_PLACEHOLDERS = ['PLACA', 'CLIENTE', 'MODELO', 'CPF', 'DATA'] as const;

export type ReceptionTermPlaceholder = (typeof RECEPTION_TERM_PLACEHOLDERS)[number];

export const GetPlaceReceptionTermTemplateResponseSchema = z.object({
  template: z.string().nullable(),
});

export type GetPlaceReceptionTermTemplateResponse = z.infer<
  typeof GetPlaceReceptionTermTemplateResponseSchema
>;

export const UpdatePlaceReceptionTermTemplateBodySchema = z.object({
  template: z.string().trim().max(4000).nullable(),
});

export type UpdatePlaceReceptionTermTemplateBody = z.infer<
  typeof UpdatePlaceReceptionTermTemplateBodySchema
>;
